import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18n';

import { useViewerTranslations } from 'hooks/useViewerTranslations';

interface ViewerTranslationsProviderProps {
  children: React.ReactNode;
  localeCode?: string;
}

/**
 * Loads form and system translations from the viewer API and provides them via react-i18next.
 * Translations are fetched and added to the i18n store; mounted components using useTranslation
 * re-render automatically via the i18n 'added'/'languageChanged' event subscriptions.
 */
export function ViewerTranslationsProvider({
  children,
  localeCode = 'en-US',
}: ViewerTranslationsProviderProps) {
  useViewerTranslations(localeCode);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
